import React from 'react';

const TermsAndConditionsEnCAAudiDucati: React.FC = () => {
    return (
        <div style={{ marginLeft: 32, marginTop: 32 }}>
            <p
                style={{ borderBottom: '1px solid black' }}
                className='pageTitle'
            >
                <h4>Terms and Conditions:</h4>
            </p>
            <p>
                Please read these terms carefully, and review them with the
                applicant, before submitting an application to Audi Finance.
            </p>
            <ol>
                <li>
                    Audi Finance may, from time to time without advance notice,
                    amend or revise these terms and conditions.
                </li>
                <li>
                    The financial services described on this site are available
                    only in Canada and may not be available in all provinces.
                </li>
                <li>
                    Eligibility for the financial services shall, except to the
                    extent provided by law, be determined solely by Audi
                    Finance.
                </li>
                <li>
                    The calculations, amounts, figures, numbers and information
                    provided at this site are estimates and are for illustrative
                    purposes only. They do not constitute an offer and are
                    subject to change at any time without advance notice.
                </li>
                <li>
                    Audi Finance makes no warranties or representations as to
                    the accuracy of the information contained on this site. By
                    using this site, you agree that Audi Finance shall have no
                    liability (whether based upon contract, tort or otherwise)
                    for direct, indirect, incidental, consequential or special
                    damages arising in any way out of the use of this site.
                </li>
                <li>
                    Information, which you provide to Audi Finance, may not be
                    on a confidential basis. Audi Finance will, however, use
                    such information in a lawful manner and for any legal
                    purpose.
                </li>
                <li>This application is being submitted on your behalf.</li>
            </ol>
            <p>
                <strong>ACKNOWLEDGEMENT AND CONSENT</strong>
            </p>
            <p>
                VW Credit Canada, Inc., o/a Audi Finance (&quot;Audi
                Finance&quot;), collects the Information (defined below) to
                determine whether to enter into an agreement with you for the
                lease or conditional sale of a motor vehicle (as applicable, the
                &quot;Contract&quot;), if we accept your application, to
                complete and administer the Contract, which includes collecting,
                storing, using, maintaining and disclosing the Information in
                accordance with the applicable Audi(as defined below) Privacy
                Policy.
            </p>
            <p>
                &quot;Information&quot; means all pertinent personal information
                we collect about you including credit, employment, vehicle
                insurance, financial medical information if you are in a vehicle
                accident, as well as any other information we obtain about you
                in the course of your Contract with us. From the date of this
                application and until all your obligations under the Contract
                are entirely satisfied, you agree that Audi Finance and Audi
                Canada Inc. (&quot;Audi Canada&quot; and, collectively with Audi
                Finance &quot;Audi&quot;) may use your Information for
                confirming your identity (e.g. name, date of birth, and contact
                information), for initial and ongoing credit assessment,
                including information about your financial and credit history
                and worthiness, from any credit reporting agency, including
                those mentioned below. We can use this Information to produce a
                custom evaluation/score of your credit worthiness, even if your
                application is declined, or you are approved, but do not enter a
                Contract with us. We may use this custom score to determine
                whether we will conclude a Contract with you and extend any
                credit to you. If we conclude a Contract with you, Audi can also
                use your information for vehicle insurance tracking, internal
                administration, contract and security publication vehicle
                registrations, end of lease administration and sale to you if
                you choose to purchase your leased vehicle, vehicle warranties,
                vehicle servicing and recalls, collection and recovery and any
                other purposes required or permitted by law. With your consent,
                Audi may also use Information during and after the Contract ends
                for marketing purposes.
            </p>
            <p>Information:</p>
            <ul>
                <li>
                    may be stored at Audi Finance&rsquo;s office located at
                    500-1340 Pickering Pky, Pickering, ON, L1V 0C4, at the
                    office of the authorized Audi Canada dealer referenced
                    above, on servers located outside Canada (including in the
                    USA and Germany), at the office of Audi Canada located at
                    777 Bayly St. West, Ajax, ON, and/or transferred outside of
                    Canada for processing, and may be subject to the laws of
                    such foreign jurisdictions an may be accessed by law
                    enforcement authorities or the local courts;
                </li>
                <li>
                    is accessible to only those Audi employees, affiliated
                    corporations, and authorized representatives, and to similar
                    persons associated with the Audi Canada dealer referenced
                    above whose job description, duties, functions and mandate
                    necessitates and justifies the access and use of your
                    Information;
                </li>
                <li>
                    may be communicated, transferred, stored and/or processed by
                    third party service providers, payment processors, lenders,
                    credit evaluation agencies, Equifax Canada Co. (Box 190,
                    Jean Talon Station, Montreal, Quebec, H1S 2Z2) and Trans
                    Union of Canada, Inc. (Consumers Relations, P.O. Box 338,
                    LCD1, Hamilton, Ontario, L8L 7W2), (this includes sharing a
                    negative report if you do not meet your obligations, which
                    may have a negative impact on your credit), with which
                    agency you may communicate and have access to your credit
                    report and have it rectified, if required, or other
                    Audi-affiliated entities in other countries; and
                </li>
                <li>
                    may be disclosed for our financing with Audi&rsquo;s
                    lenders, an entity that may purchase all or part of
                    Audi&rsquo;s business, or the entity or entities resulting
                    from Audi corporate reorganizations.
                </li>
            </ul>
            <p>
                Audi and its service providers maintain high standards of
                physical, electronic and procedural safeguards to guard your
                Information, and will retain it only as long as is required or
                permitted by law.
            </p>
            <p>
                You have the right to access and/or correct your Information at
                any time. You may contact Audi Finance or Audi Canada at the
                respective addresses noted below.
            </p>
            <p>
                For more information, you can find Audi Finance&rsquo;s Privacy
                Policy{' '}
                <a href='https://www.audifinance.ca/Public/PrivacyPolicy'>
                    here{' '}
                </a>{' '}
                and at:{' '}
                <a href='https://www.audifinance.ca'>www.audifinance.ca</a>
            </p>
            <p>
                You can find Audi Canada&rsquo;s Privacy Policy{' '}
                <a href='https://www.audi.ca/ca/web/en.html#layer=/ca/web/en/tools/navigation/layer/legal/privacy.html'>
                    here{' '}
                </a>
                and at: <a href='https://www.audi.ca'>www.audi.ca</a>
            </p>
            <p>
                <strong>
                    <u>BY SIGNING BELOW, YOU:</u>
                </strong>
            </p>
            <ol style={{ listStyleType: 'lower-roman' }}>
                <li>
                    <strong>
                        <u>
                            CONSENT TO US OBTAINING A CREDIT REPORT ABOUT YOU
                            NOW AND FOR ONGOING CREDIT ASSESSMENTS OF YOU UNTIL
                            THE CONTRACT IS PAID IN FULL AND EXECUTED IN ITS
                            ENTIRETY, AND THAT WE MAY SHARE YOUR INFORMATION
                            WITH SUCH CREDIT REPORTING AGENCIES
                        </u>
                    </strong>
                    ;
                </li>
                <li>
                    <strong>
                        consent to the Audi Canada dealer referenced above
                        sharing your Information with Audi Finance for the
                        purpose of evaluating your application for credit;
                    </strong>
                </li>
                <li>
                    <strong>
                        consent to Audi Finance continuing to administer any
                        Contract that you may sign in accordance with this
                        application for credit and to Audi Finance sharing your
                        Information as reasonably required to administer any
                        such Contract;
                    </strong>
                </li>
                <li>
                    <strong>
                        represent and warrant that there are no bankruptcy
                        proceedings or proposals against you, and the
                        Information is true and correct.
                    </strong>
                </li>
            </ol>
            <p>
                In addition, Audi Finance, and Audi, are each seeking the
                consent of each individual signing below for the purposes set
                out in 1 and 2 below under the heading &quot;Purpose&quot;.
            </p>
            <p>You can unsubscribe at any time by:</p>
            <ul>
                <li>calling 1.888.412.2834 or</li>
                <li>
                    by writing to: 500-1340 Pickering Pky, Pickering, Ontario,
                    L1V 0C4
                </li>
                <p>Attention: Privacy Officer.</p>
            </ul>
            <table
                style={{
                    width: '720px',
                    border: '1px solid black',
                    borderCollapse: 'collapse',
                }}
            >
                <tbody>
                    <tr>
                        <td
                            style={{ width: '343px', textAlign: 'center' }}
                            colSpan={2}
                        >
                            <p>
                                <strong>CONSENT</strong>
                            </p>
                        </td>
                        <td style={{ width: '363px', textAlign: 'center' }}>
                            <p>
                                <strong>PURPOSE</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px', textAlign: 'center' }}>
                            <p>
                                <strong>Applicant</strong>
                            </p>
                        </td>
                        <td style={{ width: '195.25px', textAlign: 'center' }}>
                            <p>
                                <strong>Co-Applicant/Guarantor</strong>
                            </p>
                        </td>
                        <td style={{ width: '363px' }} rowSpan={2}>
                            <p>
                                1. To Audi Finance&#39s and/or Audi&#39s use of
                                my personal information to send me marketing
                                information about new vehicles, products or
                                services, events and promotional or loyalty
                                offers including finance or lease offers
                                (&quot;Marketing Material&quot;).
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px' }}>
                            <p>
                                <input type='checkbox' /> I consent
                                <br /> <input type='checkbox' /> I do not
                                consent
                            </p>
                        </td>
                        <td style={{ width: '195.25px' }}>
                            <p>
                                <input type='checkbox' /> I consent
                                <br /> <input type='checkbox' /> I do not
                                consent
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px' }}>
                            <p>
                                <input type='checkbox' /> I consent
                                <br /> <input type='checkbox' /> I do not
                                consent
                            </p>
                        </td>
                        <td style={{ width: '195.25px' }}>
                            <p>
                                <input type='checkbox' /> I consent
                                <br /> <input type='checkbox' /> I do not
                                consent
                            </p>
                        </td>
                        <td style={{ width: '363px' }}>
                            <p>
                                2. To receive communications related to the
                                Contract and, if you consent above, Marketing
                                Materials in an electronic format (e.g. by email
                                or text message).
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                The parties hereby confirm that they expressly have requested
                that the present document be drafted in the English language.
                Les parties confirment par les présentes qu&rsquo;elles ont
                expressément demandé que le présent document soit rédigé en
                langue anglaise.
            </p>
            <p>
                <strong>
                    I agree that I have had the opportunity to read this
                    Acknowledgment and Consent before signing it and that I have
                    received a copy of it.
                </strong>
            </p>
            <table>
                <tbody>
                    <tr>
                        <td style={{ width: '482px' }}>
                            <p>Signature of Applicant</p>
                        </td>
                        <td style={{ width: '132px' }}>
                            <p>Date:</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '482px' }}>
                            <p>Signature of Co-Applicant/Guarantor</p>
                        </td>
                        <td style={{ width: '132px' }}>
                            <p>Date:</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TermsAndConditionsEnCAAudiDucati;
